import React, { useEffect, useState } from 'react';
import { omit } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLoading,
  getTotal,
  getSearch,
  getValidateFileLoading,
  getProcessResourceLoading,
  getProcessStatus,
  getDeleteFileLoading,
  getProcessCleanupResponse,
} from './resources-reducer';
import { fetchResourceCleanupDetails, updateProcessCleanupResponse } from './resources-action';
import { UploadModal } from '../templates/UploadModal';

import BaseGrid from '../grid/BaseGrid';
import { Button } from 'antd';
import { ResponseModal } from '../templates/ResponseModal';
import { getUploadResponse } from '../templates/templates-selector';
import { importFileFailed } from '../templates/templates-actions';

export const ResourceCleanup = () => {
  const dispatch = useDispatch();
  const search = useSelector(getSearch);
  const total = useSelector(getTotal);
  const loading = useSelector(getLoading);
  const [openUpload, setOpenUpload] = useState(false);
  const validateFileLoading = useSelector(getValidateFileLoading);
  const proecssCleanupLoading = useSelector(getProcessResourceLoading);
  const processStatus = useSelector(getProcessStatus);
  const deleteStatus = useSelector(getDeleteFileLoading);
  const processCleanupResponse = useSelector(getProcessCleanupResponse);
  const [showResponse, setShowResponse] = useState(false);

  let uploadResponse = useSelector(getUploadResponse);

  useEffect(() => {
    dispatch(fetchResourceCleanupDetails(''));
  }, []);

  useEffect(() => {
    if (processCleanupResponse) setShowResponse(true);
    else setShowResponse(false);
  }, [processCleanupResponse]);

  useEffect(() => {
    if (uploadResponse) setShowResponse(true);
    else setShowResponse(false);
  }, [uploadResponse]);

  const onPageChange = (pageData) => {
    dispatch(fetchResourceCleanupDetails(''));
  };

  const uploadCancel = () => {
    setOpenUpload(false);
  };

  const onOk = () => {
    dispatch(updateProcessCleanupResponse(null));
    dispatch(fetchResourceCleanupDetails(''));
    dispatch(importFileFailed(null));
  };

  return (
    <>
      <div className='search-container'>
        <Button
          type='primary'
          onClick={() => {
            setOpenUpload(true);
          }}
          disabled={total === 0 ? false : !processStatus}
        >
          Upload file
        </Button>
      </div>
      <BaseGrid
        id={'resourcecleanup'}
        total={total}
        search={search}
        setSearch={onPageChange}
        loading={loading || validateFileLoading || proecssCleanupLoading || deleteStatus}
      />
      <UploadModal visible={openUpload} data={null} onCancel={uploadCancel} type={'Resource cleanup'} />
      <ResponseModal
        visible={showResponse}
        data={processCleanupResponse || uploadResponse}
        type={processCleanupResponse ? 'ProcessCleanupResponse' : 'uploadResponse'}
        onOk={onOk}
      />
    </>
  );
};
